module.exports = __webpack_public_path__ + "img/document.5c7ac876.svg";